import { EventReport, PlayerEventReporter } from './interfaces';
import { NonStdPlayerEvents } from '../constants';

const bitrateChangeHandler = (
  event: EventReport,
  reporter: PlayerEventReporter
): boolean => {
  if (event.e != NonStdPlayerEvents.playbackbitratechanged.code) {
    return false;
  }
  const bc = reporter.config.report.max.bc;
  const len = reporter.pending.bitrates.data.length;
  const oldBitrate = reporter.state.b;
  const { b, t } = event;
  // We only want to add an event if the bitrate is not the same as previous,
  // not equal to -1, and is defined
  if (bc > len && b && b != -1 && oldBitrate != b) {
    reporter.state.novelData = true;
    reporter.pending.bitrates.data.push({ b, t });
    reporter.state.b = b;
  }
  return true;
};

export default bitrateChangeHandler;
